import React from "react";
import { config } from "../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট

const imageUrl = config.imageUrl;

const UpdateHome = ({ formData, handleChange, handleImageChange, handleQuillChange, handleSubmit, setPhoto, loading, error, onCancel }) => {
  return (
    <div className="p-6 mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Homepage</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Top Bar */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Top Bar</label>
          <input
            type="text"
            name="topBar"
            value={formData.topBar}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter top bar text"
          />
        </div>

        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter headline"
            required
          />
        </div>

        {/* Sub Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Sub Headline</label>
          <input
            type="text"
            name="subHeadline"
            value={formData.subHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter sub headline"
          />
        </div>

        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

        {/* Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Paragraph</label>
          <textarea
            name="paragraph"
            value={formData.paragraph}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter paragraph text"
          ></textarea>
        </div>

        {/* Image Upload */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Image</label>
          {formData.image && (
            <img
              src={`${imageUrl}/${formData.image}`}
              alt="Current"
              height={200}
              width={200}
              className="mb-2"
            />
          )}
          <input
            type="file"
            name="image"
            onChange={handleImageChange}
            accept="image/*"
            className="border w-full p-2"
          />
        </div>

        {/* Time Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Time Text</label>
          <input
            type="text"
            name="timeText"
            value={formData.timeText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Next Masterclass, Next Webinar, etc."
          />
        </div>

        {/* Starts Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Starts Text</label>
          <input
            type="text"
            name="startsText"
            value={formData.startsText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Starts in"
          />
        </div>

        {/* Starts In */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Starts In</label>
          <input
            type="text"
            name="startsIn"
            value={formData.startsIn}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., 10 minutes"
          />
        </div>

        {/* Seat Grab Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Seat Grab Text</label>
          <input
            type="text"
            name="seatGrabText"
            value={formData.seatGrabText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter seat grab text"
          />
        </div>

        {/* Button Headline Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Button Headline Text</label>
          <input
            type="text"
            name="buttonHeadlineText"
            value={formData.buttonHeadlineText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter button headline text"
          />
        </div>

        {/* Button Subheadline Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Button Subheadline Text</label>
          <input
            type="text"
            name="buttonSubheadlineText"
            value={formData.buttonSubheadlineText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter button subheadline text"
          />
        </div>

        {/* Secrets Headline */}
        {/* <div className="mb-4">
          <label className="block text-gray-700 font-medium">Secrets Headline</label>
          <input
            type="text"
            name="secretsHeadline"
            value={formData.secretsHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter secrets headline"
          />
        </div> */}

        {/* Secrets Text */}
        {/* <div className="mb-4">
          <label className="block text-gray-700 font-medium">Secrets Text</label>
          <ReactQuill
            value={formData.secretsText || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div> */}

        {/* Footer Text */}
        {/* <div className="mb-4">
          <label className="block text-gray-700 font-medium">Footer Text</label>
          <textarea
            name="footerText"
            value={formData.footerText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter footer text"
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}

        {/* Submit Button */}
        <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Homepage"}
            </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateHome;
